import { requestBaseService } from './index'
import { convertObjectToQueryString } from '../../utils'

export const getContents = (payload) => {
  const paramtoQuery = convertObjectToQueryString({
    ...payload.params,
    published_on: 'education',
  })
  return requestBaseService({
    url: `content/ex/v1/post`,
    method: 'GET',
    params: {
      page: payload?.params?.page,
      size: payload?.params?.size,
      sort: 'updated_at desc',
      query: paramtoQuery,
    },
  })
}

export const getContentDetail = (payload) => {
  return requestBaseService({
    url: `content/ex/v1/post/${payload.id}`,
    method: 'GET',
  })
}

export const getEducationHome = () => {
  return requestBaseService({
    url: 'content/ex/v1/post?sort=updated_at desc&query=published_on:education',
    method: 'GET',
  })
}

export const getAnalysisHome = () => {
  return requestBaseService({
    url: 'content/ex/v1/post?sort=updated_at desc&query=published_on:analysis',
    method: 'GET',
  })
}

export const getFaqHome = () => {
  return requestBaseService({
    url: 'content/ex/v1/faqs/highlights',
    method: 'GET',
  })
}

export const getLandingpage = (payload) => {
  return requestBaseService({
    url: `console/public/v1/landing-page/${payload}`,
    method: 'GET',
  })
}

const Content = {
  getContents,
  getContentDetail,
  getEducationHome,
  getAnalysisHome,
  getFaqHome,
  getLandingpage,
}

export default Content
